﻿import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderDivider, LabelValue, Checkbox, FilesList } from "components";
import { RegistrationJourneyState } from "journey";

export const SpecialRequirements = ({
  candidateDetails,
}: {
  candidateDetails: NonNullable<RegistrationJourneyState["candidateDetails"]>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider
        text={t("details.specialRequirementsTitle")}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        {candidateDetails.specialRequirements?.disability && (
          <Grid size={12}>
            <Checkbox
              readOnly
              label={t("details.disability.label")}
              value={candidateDetails.specialRequirements?.disability}
            />
          </Grid>
        )}
        {candidateDetails.specialRequirements?.dyslexia && (
          <Grid size={12}>
            <Checkbox
              readOnly
              label={t("details.dyslexia.label")}
              value={candidateDetails.specialRequirements?.dyslexia}
            />
          </Grid>
        )}
        {candidateDetails.specialRequirements?.description && (
          <Grid size={12}>
            <LabelValue
              label={t("details.specialRequirements.description.label")}
              value={candidateDetails.specialRequirements.description}
            />
          </Grid>
        )}
        {candidateDetails.specialRequirements?.files && (
          <Grid size={12}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {t("details.specialRequirements.files.label")}
            </Typography>
            <FilesList files={candidateDetails.specialRequirements.files} />
          </Grid>
        )}
      </Grid>
    </>
  );
};
